import { ReactNode } from 'react';

interface PopupFieldProps {
	label: string;
	value: string | number | null | undefined | ReactNode;
	className?: string;
}

export function PopupField({ label, value, className = '' }: PopupFieldProps) {
	if (!value) return null;

	return (
		<div className={className}>
			<span className="text-slate-600 dark:text-slate-400 text-xs">{label}:</span>
			<div className="font-medium">{value}</div>
		</div>
	);
}

interface PopupGridFieldProps {
	label: string;
	value: string | number | null | undefined | ReactNode;
}

export function PopupGridField({ label, value }: PopupGridFieldProps) {
	if (!value) return null;

	return (
		<div>
			<span className="text-slate-600 dark:text-slate-400">{label}:</span>
			<div className="font-mono">{value}</div>
		</div>
	);
}

interface PopupCoordinatesProps {
	longitude: number;
	latitude: number;
}

export function PopupCoordinates({ longitude, latitude }: PopupCoordinatesProps) {
	return (
		<div className="text-xs space-y-1 pb-2 border-b border-slate-200 dark:border-slate-700">
			<div className="flex justify-between">
				<span className="text-slate-600 dark:text-slate-400">Longitude:</span>
				<span className="font-mono">{longitude.toFixed(6)}</span>
			</div>
			<div className="flex justify-between">
				<span className="text-slate-600 dark:text-slate-400">Latitude:</span>
				<span className="font-mono">{latitude.toFixed(6)}</span>
			</div>
		</div>
	);
}
